import { render } from "./CustomerServiceNavigation.vue?vue&type=template&id=54d34f76"
import script from "./CustomerServiceNavigation.vue?vue&type=script&lang=js"
export * from "./CustomerServiceNavigation.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__